<section class="w-full space-y-3">
  <div class="flex items-baseline gap-2">
    <h2 class="text-base font-bold text-foreground">Dateien</h2>
    <span class="font-mono text-2xs text-muted-foreground">
      {{ existingFiles().length }}
      {{ existingFiles().length === 1 ? "Datei" : "Dateien" }}
    </span>
  </div>

  <app-data-table
    [data]="existingFiles()"
    [columns]="columns"
    [rowClass]="rowClass"
    [isLoading]="isLoading()"
    [showSearch]="false"
    [showAddButton]="false"
    [showLimitFilter]="false"
    emptyStateTitle="Noch keine Dateien"
    emptyStateDescription="Nach der Analyse finden Sie hier Bilder und Berichte."
  />
</section>

<ng-template #fileTpl let-file>
  <div class="flex min-w-0 items-center gap-2.5">
    <ng-icon
      [name]="getIcon(file)"
      size="16"
      class="shrink-0 text-muted-foreground"
    />
    <span class="truncate font-normal">
      {{ file.file?.filename ?? getLabel(file.tag) }}
    </span>
    @if (isSelected(file)) {
      <span hlmBadge variant="secondary" class="shrink-0 text-2xs">Eingabe</span>
    }
  </div>
</ng-template>

<ng-template #downloadTpl let-file>
  <button type="button" class="inline-flex size-9 items-center justify-center rounded-lg text-muted-foreground hover:bg-muted hover:text-foreground disabled:opacity-40" [disabled]="downloadingTag() !== null" (click)="$event.stopPropagation(); openDownload(file)" [attr.aria-label]="getLabel(file.tag) + ' herunterladen'" title="Herunterladen">
    <ng-icon name="lucideDownload" size="16" [class.animate-pulse]="downloadingTag() === file.tag" />
  </button>
</ng-template>
